import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ProgressBarModule } from 'primeng/progressbar';


// COMPONENTS
import { CandidateInfoComponent } from '../job/candidate-info/candidate-info.component';
import { WorkflowComponent } from '../job/workflow/workflow.component';
import { WorkflowManageScheduleComponent } from '../job/workflow-manage-schedule/workflow-manage-schedule.component';
import { WorkflowRulesetComponent } from '../job/workflow-ruleset/workflow-ruleset.component';
import { EventDetailsComponent } from '../events/event-details/event-details.component';
import { RoleAddComponent } from '../roles/role-add/role-add.component';
import { EventsAddComponent } from '../events/events-add/events-add.component';
import { HandleErrorComponent } from './handle-error/handle-error.component';
import { AccessManagementComponent } from '../job/access-management/access-management.component';
import { StageCandidatesComponent } from '../job/stage-candidates/stage-candidates.component';
import { InterviewPanelComponent } from '../job/interview-panel/interview-panel.component';
import { JitsiContaineComponent } from '../job/jitsi-container/jitsi-container';
import { FieldsComponent } from '../forms/fields/fields.component';
import { FeedbackFormComponent } from '../forms/feedback-form/feedback-form.component';
import { SendEmailComponent } from '../talentpool/send-email/send-email.component';
import { InviteCandidateComponent } from '../talentpool/invite-candidate/invite-candidate.component';
import { OtpVerificationComponent } from '../job/otp-verification/otp-verification.component';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { CandidateBasicInfoComponent } from '../talentpool/candidate-basic-info/candidate-basic-info.component';
import { InterviewAnalysisComponent } from '../job/interview-analysis/interview-analysis.component';

// PRIME-NG MODULES
import { SplitButtonModule } from 'primeng/splitbutton';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TimelineModule } from 'primeng/timeline';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SkeletonModule } from 'primeng/skeleton';
import { TextareaModule } from 'primeng/textarea';
import { PanelModule } from 'primeng/panel';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { BadgeModule } from 'primeng/badge';
import { InplaceModule } from 'primeng/inplace';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { PasswordModule } from "primeng/password";
import { InputNumberModule } from 'primeng/inputnumber';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SliderModule } from 'primeng/slider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FieldsV2Component } from '../forms/fields-v2/fields-v2.component';
import { GetSafeHTMLEmailPipe } from '../pipes/getSafeHTMLEmail.pipe';
import { AuthenticationCarouselComponent } from "../authentication-carousel/authentication-carousel.component";
import { InnerHtmlViewComponent } from "src/app/shared/innerhtml.component";
import { TitleCaseUnderscorePipe } from '../pipes/titleCaseUnderscore.pipe';
import { DatePicker } from "primeng/datepicker";
import { Popover } from "primeng/popover";
import { Select } from "primeng/select";
import { Drawer } from "primeng/drawer";
import { AutoComplete } from "primeng/autocomplete";
import { ToggleSwitch } from "primeng/toggleswitch";

@NgModule({
  declarations: [
    CandidateInfoComponent,
    WorkflowComponent,
    WorkflowManageScheduleComponent,
    WorkflowRulesetComponent,
    EventDetailsComponent,
    EventsAddComponent,
    RoleAddComponent,
    HandleErrorComponent,
    AccessManagementComponent,
    StageCandidatesComponent,
    InterviewPanelComponent,
    InterviewAnalysisComponent,
    JitsiContaineComponent,
    FeedbackFormComponent,
    FieldsComponent,
    SendEmailComponent,
    OtpVerificationComponent,
    InviteCandidateComponent,
    ForgetPasswordComponent,
    CandidateBasicInfoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DividerModule,
    InputTextModule,
    SplitButtonModule,
    DividerModule,
    CheckboxModule,
    EditorModule,
    ProgressSpinnerModule,
    ToastModule,
    DialogModule,
    InputTextModule,
    InputMaskModule,
    TimelineModule,
    RadioButtonModule,
    SkeletonModule,
    TextareaModule,
    PanelModule,
    MultiSelectModule,
    NgxDropzoneModule,
    AccordionModule,
    TableModule,
    BadgeModule,
    InplaceModule,
    ConfirmPopupModule,
    ButtonModule,
    ChipModule,
    MenuModule,
    AvatarModule,
    MenubarModule,
    TooltipModule,
    PasswordModule,
    InputNumberModule,
    NgxExtendedPdfViewerModule,
    ConfirmDialogModule,
    SliderModule,
    DragDropModule,
    ProgressBarModule,
    NgCircleProgressModule.forRoot({
        radius: 15,
        outerStrokeWidth: 6,
        innerStrokeWidth: 2,
        outerStrokeColor: "#4882c2",
        innerStrokeColor: "#e7e8ea",
        animationDuration: 300,
        showSubtitle: false,
        showUnits: false,
        showBackground: false,
        startFromZero: false,
    }),
    FieldsV2Component,
    GetSafeHTMLEmailPipe,
    AuthenticationCarouselComponent,
    InnerHtmlViewComponent,
    TitleCaseUnderscorePipe,
    DatePicker,
    Popover,
    Select,
    Drawer,
    AutoComplete,
    ToggleSwitch
],
  exports: [
    CandidateInfoComponent,
    WorkflowComponent,
    InterviewPanelComponent,
    InterviewAnalysisComponent,
    WorkflowManageScheduleComponent,
    WorkflowRulesetComponent,
    EventDetailsComponent,
    EventsAddComponent,
    RoleAddComponent,
    HandleErrorComponent,
    AccessManagementComponent,
    StageCandidatesComponent,
    JitsiContaineComponent,
    FeedbackFormComponent,
    SendEmailComponent,
    FieldsComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DividerModule,
    InputTextModule,
    SplitButtonModule,
    DividerModule,
    CheckboxModule,
    EditorModule,
    ProgressSpinnerModule,
    ToastModule,
    DialogModule,
    InputTextModule,
    InputMaskModule,
    TimelineModule,
    RadioButtonModule,
    SkeletonModule,
    TextareaModule,
    PanelModule,
    MultiSelectModule,
    NgxDropzoneModule,
    AccordionModule,
    TableModule,
    BadgeModule,
    InplaceModule,
    ConfirmPopupModule,
    ButtonModule,
    ChipModule,
    MenuModule,
    AvatarModule,
    MenubarModule,
    TooltipModule,
    PasswordModule,
    InputNumberModule,
    NgxExtendedPdfViewerModule,
    ConfirmDialogModule,
    SliderModule,
    InviteCandidateComponent,
    OtpVerificationComponent,
    ForgetPasswordComponent,
    CandidateBasicInfoComponent,
    ProgressBarModule,
    NgCircleProgressModule,
    GetSafeHTMLEmailPipe,
  ],
  providers: []
})
export class SharedModule {}
